
export default {
name: 'serve',
components: {

},
data () {
return {

}
},
methods: {
myCollect () {
this.$router.push({
path: '/myCollect'
})
}
},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/serve/script.js